import { AxiosError } from 'axios';

export const apiErrorMessage = (error: unknown): string | undefined => {
  const data = (error as Partial<AxiosError>)?.response?.data as
    Partial<{ body: { detail: string }; message: string }> | undefined;

  return data?.message ?? data?.body?.detail;
};
